import { DateTime } from 'luxon';
import { GERMAN_TIMEZONE } from '../../constants';
import { BookingsService } from '../../api/BookingsService';

// The one "now" for every time-gated booking rule (express surcharge, earliest bookable
// day, phone-only banner, payment-link gate, orderDate). Synced once per session against
// GET /booking/current-date so a wrong browser clock or a far-away zone cannot move it.
//
// Anchor = server instant at sync time + monotonic elapsed time since. performance.now()
// is unaffected by a device clock change after the sync. Before the first sync answers,
// the browser clock is used.
//
// ponytail: no request ordering and no transit-time compensation; the rules gate on
// minutes and days, so a clock a second behind the server changes nothing.
let anchor = null; // { serverMs, perfMs }

const syncServerClock = () =>
    BookingsService.getCurrentDateTime()
        .then((iso) => {
            const server = DateTime.fromISO(iso);
            if (server.isValid) {
                anchor = { serverMs: server.toMillis(), perfMs: performance.now() };
            }
        })
        .catch(() => {
            // keep the previous anchor (or the browser clock); never surfaced to the customer
        });

const nowInGermany = () => {
    const ms = anchor ? anchor.serverMs + (performance.now() - anchor.perfMs) : Date.now();
    return DateTime.fromMillis(ms).setZone(GERMAN_TIMEZONE);
};

// test seam only
const resetServerClock = () => {
    anchor = null;
};

export { syncServerClock, nowInGermany, resetServerClock };
